import React, { useReducer, useContext, useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
/// Link
import { Link } from "react-router-dom";
import { MenuList } from "./Menu";

import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { AdminMenuList, UserMenuList } from "./AdminMenu";
import { useSelector } from "react-redux";
import { SuperAdminMenuList } from "./SuperAdminMenu";
import { PlayerMenuList } from "./PlayerMenu";
import { CoachMenuList } from "./CochMenu";
import { StaffMenuList } from "./StaffMenu";
import { TenantAdminMenu } from "./TenantAdminMenu";
// import LogoutPage from './Logout';
/// Image
// import profile from "../../../assets/images/profile/pic1.jpg";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  let dat = new Date();
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);

  // Load saved state from localStorage or use default
  const savedState = localStorage.getItem("sidebarState");
  const [state, setState] = useReducer(
    reducer,
    savedState ? JSON.parse(savedState) : initialState,
  );
  const { role } = useSelector((state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    role: state.auth.role,
  }));
  const [userRole, setUserRole] = useState(role);
  const [currentMenuList, setCurrentMenuList] = useState([]);

  useEffect(() => {
    setCurrentMenuList(getMenuByRole(userRole));
  }, [userRole, role]);

  const getMenuByRole = () => {
    switch (userRole) {
      case "super-admin":
        return SuperAdminMenuList;
      case "tenant-admin":
        return TenantAdminMenu;
      case "admin":
        return AdminMenuList;
      case "player":
        return PlayerMenuList;
      case "coach":
        return CoachMenuList;
      case "staff":
        return StaffMenuList;
      default:
        return []; // empty if no valid role
    }
  };

  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll],
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
      localStorage.setItem(
        "sidebarState",
        JSON.stringify({ ...state, active: "" }),
      );
    } else {
      localStorage.setItem(
        "sidebarState",
        JSON.stringify({ ...state, active: status }),
      );
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
      localStorage.setItem(
        "sidebarState",
        JSON.stringify({ ...state, activeSubmenu: "" }),
      );
    } else {
      localStorage.setItem(
        "sidebarState",
        JSON.stringify({ ...state, activeSubmenu: status }),
      );
    }
  };

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  useEffect(() => {
    currentMenuList.forEach((data) => {
      data.content?.forEach((item) => {
        if (path === item.to) {
          setState({ active: data.title });
          localStorage.setItem(
            "sidebarState",
            JSON.stringify({ ...state, active: data.title }),
          );
        }
        item.content?.forEach((ele) => {
          if (path === ele.to) {
            setState({ activeSubmenu: item.title, active: data.title });
            localStorage.setItem(
              "sidebarState",
              JSON.stringify({ activeSubmenu: item.title, active: data.title }),
            );
          }
        });
      });
    });
  }, [path, currentMenuList]);

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`dlabnav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <div className="dlabnav-scroll">
        <ul className="metismenu" id="menu">
          {currentMenuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li
                  className={`nav-label ${menuClass} ${data.extraclass}`}
                  key={index}
                >
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={` ${
                    state.active === data.title ? "mm-active" : ""
                  }${data.to === path ? "mm-active" : ""}`}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow"
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}
                        <span className="nav-text">{data.title}</span>
                        <span className="badge badge-xs style-1 badge-danger">
                          {data.update}
                        </span>
                      </Link>
                      <Collapse in={state.active === data.title ? true : false}>
                        <ul
                          className={`${
                            menuClass === "mm-collapse" ? "mm-show" : ""
                          }`}
                        >
                          {data.content &&
                            data.content.map((data, index) => {
                              return (
                                <li
                                  key={index}
                                  className={`${
                                    state.activeSubmenu === data.title
                                      ? "mm-active"
                                      : ""
                                  }${data.to === path ? "mm-active" : ""}`}
                                >
                                  {data.content && data.content.length > 0 ? (
                                    <>
                                      <Link
                                        to={data.to}
                                        className={
                                          data.hasMenu ? "has-arrow" : ""
                                        }
                                        onClick={() => {
                                          handleSubmenuActive(data.title);
                                        }}
                                      >
                                        {data.title}
                                      </Link>
                                      <Collapse
                                        in={
                                          state.activeSubmenu === data.title
                                            ? true
                                            : false
                                        }
                                      >
                                        <ul
                                          className={`${
                                            menuClass === "mm-collapse"
                                              ? "mm-show"
                                              : ""
                                          }`}
                                        >
                                          {data.content &&
                                            data.content.map((data, index) => {
                                              return (
                                                <li key={index}>
                                                  <Link
                                                    className={`${
                                                      path === data.to
                                                        ? "mm-active"
                                                        : ""
                                                    }`}
                                                    to={data.to}
                                                  >
                                                    {data.title}
                                                  </Link>
                                                </li>
                                              );
                                            })}
                                        </ul>
                                      </Collapse>
                                    </>
                                  ) : (
                                    <Link
                                      to={data.to}
                                      className={`${
                                        data.to === path ? "mm-active" : ""
                                      }`}
                                    >
                                      {data.title}
                                    </Link>
                                  )}
                                </li>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link
                      to={data.to}
                      className={`${data.to === path ? "mm-active" : ""}`}
                    >
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
        {/* <div className="copyright">
          <p>Edumin Saas Admin © {dat.getFullYear()} All Rights Reserved</p>
          <p className="fs-12">
            Made with{" "}
            <span
              className="heart"
              onClick={(e) => e.target.classList.toggle("heart-blast")}
            ></span>{" "}
            by DexignLab
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default SideBar;
